export default __webpack_public_path__ + "static/facebook_white-62410f08a79c62574ddfe61cdf390dc1.svg";